<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <!-- Pop up for creating and editing Sub Location -->
    <v-row justify="center">
      <v-dialog v-model="addSubLocationDialog" persistent max-width="480px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center headline">
            <span class="headline">{{ actionHeadline() }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="addSubLocationDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-flex>
                    <v-autocomplete
                      color="primary"
                      v-model="input_location"
                      variant="outlined"
                      :items="locations"
                      v-if="!isEditing"
                      item-value="id"
                      item-title="code"
                      label="Location*"
                    >
                    </v-autocomplete>
                    <v-text-field
                      color="primary"
                      variant="outlined"
                      v-else
                      v-model="edit_input_location"
                      label="Location"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-flex>
                    <v-text-field
                      color="primary"
                      variant="outlined"
                      v-model.trim="input_sub_location_name"
                      label="Sub-Location Name*"
                      @input="update_binloaction_format"
                    ></v-text-field>
                  </v-flex>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-flex>
                    <v-select
                      color="primary"
                      :items="subLocation_types"
                      item-value="value"
                      item-title="name"
                      v-model="input_sub_location_type"
                      label="Sub-Location Type"
                      variant="outlined"
                    >
                    </v-select>
                  </v-flex>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-flex>
                    <v-text-field
                      variant="outlined"
                      v-model.trim="input_sub_location_id"
                      label="Sub-Location Id*"
                      @input="update_binloaction_id_format"
                    ></v-text-field>
                  </v-flex>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-flex>
                    <v-select :items="subLocation_cate_items" item-value="value" item-title="name"
                      v-model="input_sub_location_category" label="Sub-Location Category" variant="outlined">
                    </v-select>
                  </v-flex>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center">
            <v-btn size="small" variant="text" class="btn-cancel mr-2 mb-3 text-none" @click="closePopup"
              >Cancel</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              class="mb-3 text-none"
              color="primary"
              @click="saveSubLocation"
              :loading="isSubmited"
              :disabled="verifyInputs() || isSubmited"
              >{{ buttonText() }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Pop up for delete confirmation -->
    <v-row justify="center">
      <v-dialog v-model="deleteSubLocationDialog" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title> <span>Confirmation</span><br /> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <span
                  >Are you sure you want to delete the selected sub location(s)
                  ?</span
                ><br />
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="text" class="btn-cancel text-none" @click="closePopup"
              >Cancel</v-btn
            >
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="deleteSubLocationsConfirm"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Pop up for sorting sub location sequence -->
    <v-row justify="center">
      <v-dialog v-model="sortSubLocationSequence" persistent max-width="850px">
        <v-card class="v-card-100">
          <v-toolbar dark color="primary">
            <v-toolbar-title
              >Sort Sub Locations (Closest to Farthest)</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                class="text-blue bg-white text-none"
                size="small"
                @click="handleSaveSorting"
                >Save Sorting Order
              </v-btn>
              <v-btn variant="solo" icon dark @click="closePopup"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-toolbar>

          <v-layout column>
            <v-col md6 style="overflow: auto">
              <v-table class="gray-border">
                
                  <thead>
                    <tr>
                      <th class="text-left">Sequence</th>
                      <th class="text-left">Sub-Locations</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in sub_locations_items"
                      :key="item.code"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.code }}</td>
                      <td>
                        <img
                          src="@/assets/images/icons/up-arrow.svg"
                          @click="handleUp(item, index)"
                          width="25"
                          title="Move up"
                        />
                        <img
                          src="@/assets/images/icons/down-arrow.svg"
                          @click="handleDown(item, index)"
                          width="25"
                          title="Move down"
                        />
                      </td>
                    </tr>
                  </tbody>
                
              </v-table>
            </v-col>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Export Inventory popup -->
    <v-row justify="center">
      <v-dialog v-model="exportinventorypopu" max-width="750px">
        <v-card class="v-card-100">
          <v-form ref="dispatchForm">
            <v-card-title class="d-flex align-center">
              <span
                v-if="this.active_tab == 'Update Inventory'"
                class="inc-title"
                >Export Inventories</span
              >
              <span
                v-if="this.active_tab == 'Sub-Locations'"
                class="inc-title"
              >
                Export Sub-Locations</span
              >
              <span
                v-if="this.active_tab == 'Sub-Location Sequence'"
                class="inc-title"
              >
                Export Sub-Locations Sequence</span
              >
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="exportinventorypopu = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="m-0"/>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-flex>
                      <v-autocomplete
                        color="primary"
                        v-model="inventory_location"
                        :items="InventoryLocation"
                        item-title="code"
                        item-value="id"
                        placeholder="Select Location"
                        prepend-icon="mdi-magnify"
                        variant="outlined"
                        label="Select Sub-Location"
                      ></v-autocomplete>
                      <!-- <v-text-field solo v-model="vendor_code" label="Vendor Code"></v-text-field> -->
                    </v-flex>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-btn
                      class="ma-2 text-none"
                      variant="flat"
                      color="primary"
                      @click="downloadInventoryFile"
                      :disabled="!inventory_location"
                      >Download</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- upload Inventory popup -->
    <v-row justify="center">
      <v-dialog v-model="uploadinventorypopup" max-width="750px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span
              v-if="this.active_tab == 'Update Inventory'"
              class="inc-title"
              >Inventory File Upload</span
            >
            <span v-if="this.active_tab == 'Sub-Locations'" class="inc-title"
              >Sub-Locations File Upload</span
            >
            <span
              v-if="this.active_tab == 'Sub-Location Sequence'"
              class="inc-title"
            >
              Import Sub-Location Sequence
            </span>
            <v-spacer></v-spacer>
            <v-btn icon variant="plain" @click="uploadinventorypopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-text class="pa-0">
            <form
              @submit.prevent="importFile"
              enctype="multipart/form-data"
              ref="inv_file_upload_form"
            >
              <v-card-title style="display: flow-root"> </v-card-title>
              <v-card-text>
                <v-container>
                  <div>
                    <input
                      type="file"
                      class="form-control"
                      ref="file"
                      @change="selectFile"
                      :class="{ 'is-invalid': v$.file.$error }"
                    />
                    <div v-if="file_required">
                      <div class="warning_img">
                        <div class="warnig_imgw">
                          <img src="@/assets/images/icons/warning.svg" />File is
                          required
                        </div>
                      </div>
                    </div>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn
                  size="small"
                  variant="text"
                  type="button"
                  text
                  class="btn-cancel mr-2 mb-3 text-none"
                  @click="uploadinventorypopup = false"
                  >Cancel</v-btn
                >
                <v-btn
                  size="small"
                  variant="flat"
                  color="primary"
                  class="mb-3 text-none"
                  @click="importFile()"
                  :disabled="number > 0"
                  >Submit</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-putaway"
        v-model="filtersPopup"
        persistent
        max-width="680px"
      >
        <v-card  class="filter_ui">
          <v-card-actions>
            <v-combobox
              prepend-inner-icon="mdi-magnify"
              clearable
              v-model="filterLocation"
              :items="locations"
              item-title="code"
              item-value="id"
              label="Location"
              multiple
              variant="outlined"
              color="primary"
              class="ma-2"
              style="max-width: 300px"
            ></v-combobox>

            <v-combobox
              prepend-inner-icon="mdi-magnify"
              clearable
              v-model="filterLocationType"
              :items="location_type_filter"
              item-title="name"
              item-value="id"
              label="Location Type"
              variant="outlined"
              class="ma-2"
              color="primary"
              style="max-width: 300px"
            ></v-combobox>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="filtersPopup = false"
              >Cancel</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              color="primary"
              class="mb-3 text-none"
              @click="applyFilters"
              :disabled="!this.filterLocation.length > 0 && !this.filterLocationType"
              >Apply Filter(s)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- For showing tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_name" color="primary">
        <v-tab
          ripple
          style="text-transform: none !important"
          @click="loadData(tab, 'tab_clicked') || dataClear()"
          v-for="(tab, index) in tabs"
          :key="index"
          >{{ tab }}</v-tab
        >
      </v-tabs>
    </v-card>

    <!-- For showing Filters and Action buttons -->
    <v-card-title class="action-style pb-0">
    <v-row class="ma-1">
        <v-col cols="2" sm="2" class="pb-0">
        <span v-if="active_tab == 'Sub-Locations'">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="sub_location_search"
            v-no-edge-space
            label="Search"
            style="max-width: 135px"
            color="primary"
            variant="outlined"
            v-on:keyup.enter="loadData('Sub-Locations')"
          ></v-text-field>
        </span>
        <span
          v-if="active_tab == 'Sub-Location Rules' && !showRuleScreen"
        >
          <v-text-field
            color="primary"
            prepend-inner-icon="mdi-magnify"
            v-model="sub_location_rules_search"
            v-no-edge-space
            label="Search"
            style="max-width: 135px"
            variant="outlined"
            v-on:keyup.enter="loadData('Sub-Location Rules')"
          ></v-text-field>
      </span>
        <span v-if="active_tab == 'Sub-Location Sequence'">
          <v-text-field
            color="primary"
            prepend-inner-icon="mdi-magnify"
            v-model="sub_location_sequence_search"
            v-no-edge-space
            label="Search"
            style="max-width: 135px"
            variant="outlined"
            v-on:keyup.enter="loadData('Sub-Location Sequence')"
          ></v-text-field>
        </span>
      </v-col>

      <v-spacer />
      <v-actions style="margin-bottom: 28px; display: flex;" class="ma-1">
        <v-btn
          class="ma-2 text-none"
          cols="2"
          color="primary"
          style="min-height: 52px;"
          v-if="active_tab == 'Sub-Locations'"
          @click="exportInventoryPopup"
          >Export <br class="text-break"> Sublocations</v-btn
        >
        <v-btn
          class="ma-2 text-none"
          cols="1"
          sm="4"
          md="3"
          style="min-height: 52px;"
          color="primary"
          v-if="active_tab == 'Sub-Locations'"
          @click="uploadInventoryDialog"
          >Import <br class="text-break"> Sublocations</v-btn
        >
        <v-btn
          class="ma-2 text-none"
          style="min-height: 52px;"
          color="primary"
          :disabled="this.selected.length > 0"
          v-if="active_tab == 'Sub-Locations'"
          @click="addSubLocationPopupOpen"
          >Add <br class="text-break"> Sublocations</v-btn
        >

        <v-btn
          class="ma-2 text-none"
          style="min-height: 52px;"
          color="primary"
          :disabled="this.selected.length == 0 || this.selected.length > 1"
          v-if="active_tab == 'Sub-Locations'"
          @click="editSubLocationPopupOpen"
          >Edit</v-btn
        >

        <v-btn
          class="ma-2 text-none"
          variant="flat"
          style="min-height: 52px;"
          size="x-large"
          color="primary"
          :disabled="this.selected.length == 0"
          v-if="active_tab == 'Sub-Locations'"
          @click="deleteSubLocationConfirmationPopupOpen"
          >Delete</v-btn
        >
        <v-btn
          cols="2"
          class="ma-2 text-none"
          variant="flat"
          color="primary"
          style="min-height: 52px;"
          v-if="active_tab == 'Sub-Location Sequence'"
          @click="exportInventoryPopup"
          >Export Sequence</v-btn
        >
        <v-btn
          cols="1"
          sm="4"
          md="3"
          variant="flat"
          color="primary"
          class=" ma-2 text-none"
          style="min-height: 52px;"
          v-if="active_tab == 'Sub-Location Sequence'"
          @click="uploadInventoryDialog"
          >Import Sequence</v-btn
        >

        <v-btn
          class="ma-2 text-none"
          style="min-height: 52px;"
          variant="flat"
          color="primary"
          :disabled="this.selected.length > 1 || this.selected.length === 0"
          v-if="active_tab == 'Sub-Location Sequence'"
          @click="sortSubLocationSequencePopupOpen"
          >Sort Sub Locations</v-btn
        >
        <v-btn
          class="ma-2 text-none"
          style="min-height: 52px;"
          color="primary"
          @click="downloadExporRules"
          v-if="!showRuleScreen && active_tab == 'Sub-Location Rules'">Export Rules</v-btn>
        <v-btn
          class="ma-2 text-none"
          style="min-height: 52px;"
          size="x-large"
          color="primary"
          :disabled="this.selected.length == 0"
          variant="flat"
          v-if="!showRuleScreen && active_tab == 'Sub-Location Rules'"
          @click="handleruleLinkClick()"
          >Define Rule</v-btn
        >
      </v-actions>
      <!-- Update inventory -->
      <template v-if="active_tab == 'Update Inventory'">
        <v-actions style="margin-bottom: 28px;display: flex;" class="ma-1">
          <v-btn
            class="ma-2 text-none"
            style="min-height: 52px;"
            color="primary"
            v-if="active_tab == 'Update Inventory'"
            @click="exportInventoryPopup"
            >Export Inventory</v-btn
          >
          <v-btn
            class="ma-2 text-none"
            style="min-height: 52px;"
            color="primary"
            v-if="active_tab == 'Update Inventory'"
            @click="uploadInventoryDialog"
            >Import Inventory</v-btn
          >
        </v-actions>
      </template>

      <template v-if="!showRuleScreen && active_tab != 'Update Inventory'">
        <v-expansion-panels
          ref="filterPopupRef"
          class="custom-control_outlined ma-0 pt-3"
          readonly
          style="max-width: 300px; margin-bottom: 28px; height: 52px"
          v-if="active_tab !== 'Sub-Location Sequence'"
        >
          <v-expansion-panel variant="outlined" @click="listFiltersData" class="mt-0">
            <v-expansion-panel-title
              >Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-else-if="showRuleScreen && active_tab != 'Update Inventory'">
        <v-btn
          :disabled="!saveRuleBtn"
          @click="handleSaveRule"
          class="ma-2 text-none"
          variant="flat"
          color="primary"
          >Save Rule</v-btn
        >
        <v-btn
          :disabled="!saveRuleBtn"
          @click="closePopup"
          variant="text"
          class="btn-cancel ma-2 text-none"
          color="primary"
          >Cancel</v-btn
        >
      </template>
      </v-row>
    </v-card-title>

    <!-- For listing data -->
    <template v-if="!showRuleScreen && active_tab != 'Update Inventory'">
      <v-layout column>
        <v-col cols="12" style="overflow: auto" class="p-0">
          <v-data-table
            hover
            density="compact"
            v-model="selected"
            :headers="headers"
            :items="table_data"
            :items-per-page="pageSize"
            show-select
            disable-pagination
            :hide-default-footer="true"
            class="elevation-1"
            fixed-header
            height="100%"
            return-object
          >
          <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
              <span v-if="headers.key == 'rules'">
                <a href="#" @click.prevent="handleruleLinkClick(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.rules }}</a>
              </span> 
              <span v-else-if="headers.key !== 'images' && item[headers.key]">
                <span v-tooltip="item[headers.key]">
                  {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
            <!-- <template #[`item.rules`]="{ item }">
              <a @click="handleruleLinkClick(item)" style="color: #1976d2">
                <u> {{ item.rules }}</u>
              </a> -->
              <!-- <span v-else>{{ item.rules }}</span> -->
            <!-- </template> -->
            <template #bottom></template>
          </v-data-table>
        </v-col>
      </v-layout>
      <!-- pagination -->
      <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />

    </template>
    <template v-else-if="showRuleScreen">
      <v-card>
        <v-card-title style="padding: 28px">
          <span>Rule Type</span>
        </v-card-title>
        <v-card-text>
          <v-container
            v-for="ruleOption in ruleOptions"
            :key="ruleOption.ruleName"
            class="rule-ct_chips"
          >
            <v-card-actions>
              <input
                type="checkbox"
                :checked="ruleOption.checked"
                id="item.ruleName"
                name="check"
                style="width: 18px; height: 18px; margin-top: 2px"
                class="checkbox"
                @change="handleCheckRule(ruleOption)"
              />
              <span class="ml-2">{{ ruleOption.ruleName }}</span>
            </v-card-actions>
            <template v-if="ruleOption.show">
              <!-- <input type="text"/> -->
              <!-- <div v-if="ruleOption.ruleName == 'Quantity'" style="display: flex">
                <v-autocomplete v-model="requestReason" variant="outlined" :items="ruleOption.Options" item-title="key"
                  item-value="value" label="" style="max-width: 150px;" />
                <v-text-field v-model="sub_location_search" label="No. of items" variant="outlined"></v-text-field>
              </div> -->
            
                <div class="row">
                  <div class="col-6">
                    <v-autocomplete
                      v-model="ruleOption.selectedValue"
                      variant="outlined"
                      color="primary"
                      :items="ruleOption.Options"
                      item-title="key"
                      item-value="value"
                      :label="ruleOption.label"
                      style="max-width: 300px"
                      multiple
                      chips
                      closable-chips
                      deletable-chips
                    >
                    </v-autocomplete>
                  </div>
                  <div class="col-6">
                    <div>
                      <div class="mb-2 text-left">
                        <span class="v-label"
                          >Selected {{ ruleOption.ruleName }}</span
                        >
                      </div>
                      <div class="selected_rule_box">
                        <span
                          v-for="item in ruleOption.selectedValue"
                          :key="item"
                          class="rule-type_option"
                        >
                          {{ item }}
                          <span
                            style="color: #000000; cursor: pointer"
                            class="text-black"
                            @click="handleRemoveSelect(ruleOption, item)"
                            >x</span
                          ></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
            
            </template>
          </v-container>
        </v-card-text>
      </v-card>
    </template>
  </v-card>
</template>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
// import { required } from "vuelidate/lib/validators";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import {API_URL} from "@/backend/axios/index.js"
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      headerText: "Settings",
      loading: false,
      alert: false,
      active_tab: "Sub-Locations",
      tabs: [
        "Sub-Locations",
        "Sub-Location Rules",
        "Sub-Location Sequence",
        "Update Inventory",
      ],
      tab_name: "0",
      sequence_items: [],
      sub_locations_items: [],
      table_data: [],
      singleSelect: false,
      selected: [],
      sub_location_search: "",
      sub_location_sequence_search: "",
      sub_location_rules_search: "",
      dialog: false,
      deleteSubLocationDialog: false,
      addSubLocationDialog: false,
      disableAddButton: false,
      sortSubLocationSequence: false,
      input_location: "",
      edit_input_location: "",
      input_sub_location_type: "",
      input_sub_location_name: "",
      input_sub_location_id: "",
      subLocation_types: [
        { name: "Open", value: "open" },
        { name: "Closed", value: "closed" },
      ],
      locations: [],
      location_type_filter: [],
      isSubmited: false,
      isEditing: false,
      headers: [
        {
          title: "Sub Location ID",
          key: "code",
        },
        { title: "Sub Location Name", key: "name" },
        { title: "Location", key: "distribution_center" },
        { title: "Location Type", key: "location_type" },
        { title: "Added On", key: "created_at" },
      ],
      sequence_headers: [
        {
          title: "Sequence",
          align: "start",
          sortable: false,
          key: "tag_number",
          width: "10%",
        },
        { title: "", key: "=====", width: "5%" },
        { title: "Sub-Locations", key: "item_description", width: "20%" },
        { title: "", key: "" },
      ],
      filterLocation: [],
      filterLocationType: [],
      alert_type: "success",
      alert_message: "success",
      insurance_title: "Insurance Submission",
      dialog_confirm: "",
      action: "",
      selected_inv: "",
      viewAttachmentDialog: false,
      page: 1,
      totalPages: 1,
      totalCount : '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      alert_value: "",
      alert_item: [
        { name: "All", value: "" },
        { name: "High", value: "high" },
        { name: "Medium", value: "medium" },
        { name: "Low", value: "low" },
      ],
      filtersPopup: false,
      showRuleScreen: false,
      updateInventory: false,
      exportinventorypopu: false,
      inventory_location: null,
      InventoryLocation: "",
      file: "",
      file_required: false,
      uploadinventorypopup: false,
      number: 0,
      ruleOptions: [
        {
          ruleName: "Category",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Categories",
          selectedValue: [],
          ApiKey: "categories",
          updatekey: "category",
        },
        {
          ruleName: "Brand",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Brand",
          selectedValue: [],
          ApiKey: "brands",
          updatekey: "brand",
        },
        {
          ruleName: "Grade",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Grade",
          selectedValue: [],
          ApiKey: "grades",
          updatekey: "grade",
        },
        {
          ruleName: "Disposition",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Disposition",
          selectedValue: [],
          ApiKey: "dispositions",
          updatekey: "disposition",
        },
        {
          ruleName: "Return Reason",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Return Reason",
          selectedValue: [],
          ApiKey: "return_reasons",
          updatekey: "return_reason",
        },
      ],
      saveRuleBtn: false,
      subLocation_cate_items:[{ name: 'Storage', value: 'storage' }, { name: 'Dispatch', value: 'dispatch' }],
      input_sub_location_category:'',
      category_update:''
    };
  },

  components: {
    HeaderComponent,
  },
  validations: {
    file: { required },
  },

  created() {
    const tab = this.$store.state.active_tab
    if(tab == 'Update Inventory'){
      this.tab_name = 3;
      this.loadData("Update Inventory");
    } else if(tab == 'Sub-Location Sequence'){
      this.tab_name = 2;
      this.loadData("Sub-Location Sequence");
    }else if(tab == 'Sub-Location Rules'){
      this.tab_name = 1;
      this.loadData("Sub-Location Rules");
    } else {
      this.tab_name = 0;
      this.loadData("Sub-Locations");
    }
    this.getLocations();
  },

  methods: {
    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },

    handleUp(item, index) {
      if (index !== 0) {
        const remainingItem = this.sub_locations_items.filter(
          (value) => value.id !== item.id,
        );
        remainingItem.splice(index - 1, 0, item);
        this.sub_locations_items = remainingItem;
      }
    },
    handleDown(item, index) {
      if (index !== this.sub_locations_items.length - 1) {
        const remainingItem = this.sub_locations_items.filter(
          (value) => value.id !== item.id,
        );
        remainingItem.splice(index + 1, 0, item);
        this.sub_locations_items = remainingItem;
      }
    },
    handleSaveSorting() {
      const sequence_items = this.sub_locations_items.map((item, ind) => {
        return { sequence: ind + 1, id: item.id };
      });
      this.$httpSecured
        .put(
          `/api/v1/warehouse/distribution_centers/${this.selected[0].id}/update_sequence`,
          { sub_locations: sequence_items },
        )
        .then((response) => {
          if (response.status === 200) {
            this.loadData("Sub-Location Sequence");
            this.sortSubLocationSequence = false;
            this.showAlert(
              "success",
              "Sub-Location sequence updated successfully",
            );
          } 
        })
        .catch((error) => {
          // console.log(error, "update_sequence api error");
        });
    },

    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },

    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    buttonText() {
      if (this.isEditing) {
        return "Update";
      } else {
        return "Add";
      }
    },

    actionHeadline() {
      return this.isEditing ? "Edit Sub Location" : "Add Sub Location";
    },

    getLocations() {
      this.$httpSecured
        .get("/api/v1/warehouse/sub_locations/get_locations")
        .then((response) => {
          if (response.data) {
            this.locations = response.data.locations;
            this.location_type_filter = response.data.location_types;
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },

    listFiltersData(ev) {
      this.sub_location_rules_search = "";
      this.sub_location_search = "";
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20
        ).toString() + "px",
      );
      this.filtersPopup = true;
    },

    applyFilters() {
      const params = new URLSearchParams();

      if (this.filterLocation) {
        params.append(
          "distribution_center_ids",
          JSON.stringify(this.filterLocation.map((x) => x.id)),
        );
      }

      if (this.filterLocationType) {
        params.append("location_type", this.filterLocationType.id);
      }

      const pageparams = this.getRequestParams(this.page, this.pageSize);
      params.append("page", pageparams["page"]);
      params.append("per_page", pageparams["size"]);
      var apiUrl = ''
      if (this.active_tab == "Sub-Locations") {
         apiUrl = "/api/v1/warehouse/sub_locations";
      } else {
         apiUrl = "/api/v1/warehouse/sub_locations/sub_location_rules";
      }

      this.$httpSecured
        .get(`${apiUrl}`, { params })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.sub_locations;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filterLocation = "";
            this.filterLocationType = "";
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    disableFilterSubmit() {
      return this.filterLocation && this.filterLocation.length == 0 || this.filterLocationType == "";
    },

    loadData(tab, tab_action) {
      if (tab_action) {
        this.sub_location_search = "";
        this.sub_location_sequence_search = "";
        this.sub_location_rules_search = "";
      }
      this.loading = true;
      this.selected = [];
      this.active_tab = tab;
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      this.showRuleScreen = false;
      this.ruleOptions = this.ruleOptions.map((item) => ({
        ...item,
        Options: [],
        selectedValue: [],
        show: false,
        checked: false,
      }));
      this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
      if (tab == "Sub-Locations") {
        this.sub_location_rules_search = "";
        this.sub_location_sequence_search = "";
        this.filterLocationType = null;
        this.headers = [
          {
            title: "Sub Location ID",
            key: "code",
          },
          { title: "Sub Location Name", key: "name" },
          { title: "Sub Location Category", key: "sub_location_category" },
          { title: "Location", key: "distribution_center" },
          { title: "Location Type", key: "location_type" },
          { title: "Updated At", key: "last_updated" },
        ];

        this.fetchSubLocations();
      }

      if (tab == "Sub-Location Sequence") {
        this.sub_location_rules_search = "";
        this.sub_location_search = "";
        this.headers = [
          {
            title: "Location",
            align: "location",
            key: "code",
          },
          { title: "No. of Sub Location", key: "sub_locations" },
          { title: "Sorting Status", key: "status" },
        ];

        this.fetchSubLocationsSequence();
      }

      if (tab == "Sub-Location Rules") {
        this.sub_location_sequence_search = "";
        this.sub_location_search = "";
        this.headers = [
          { title: "Sub Location", align: "location", key: "code" },          
          { title: "Sub Location Category", key: "sub_location_category" },
          { title: "Location", key: "distribution_center" },
          { title: "Location Type", key: "location_type" },
          { title: "Rules", key: "rules" },
        ];

        this.fetchSubLocationRules();
      }
      if (tab == "Update Inventory") {
        this.updateInventory = true;
        this.sequence_headers = [];
        this.headers = [];
      }
    },

    fetchSubLocations() {
      const params = this.getRequestParams(this.page, this.pageSize);
      this.$httpSecured
        .get("/api/v1/warehouse/sub_locations", {
          params: {
            search: this.sub_location_search,
            page: params["page"],
            per_page: params["size"],
          },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.sub_locations;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    fetchSubLocationsSequence() {
      const params = this.getRequestParams(this.page, this.pageSize);
      this.$httpSecured
        .get("/api/v1/warehouse/distribution_centers", {
          params: {
            search: this.sub_location_sequence_search,
            page: params["page"],
            per_page: params["size"],
          },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.distribution_centers;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    fetchSubLocationRules() {
      const params = this.getRequestParams(this.page, this.pageSize);

      this.$httpSecured
        .get("/api/v1/warehouse/sub_locations/sub_location_rules", {
          params: {
            search: this.sub_location_rules_search,
            page: params["page"],
            per_page: params["size"],
          },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.sub_locations;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filterLocation = null;
            this.filterLocationType = null;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    handlePageChange(value) {
      this.page = value;
      if (this.active_tab == "Sub-Locations") {
        this.fetchSubLocations();
      } else if (this.active_tab == "Sub-Location Rules") {
        this.fetchSubLocationRules();
      } else {
        this.fetchSubLocationsSequence();
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      if (this.active_tab == "Sub-Locations") {
        this.fetchSubLocations();
      } else if (this.active_tab == "Sub-Location Rules") {
        this.fetchSubLocationRules();
      } else {
        this.fetchSubLocationsSequence();
      }
    },
    verifyInputs() {
      return (
        this.input_location == "" ||
        this.input_sub_location_type == "" ||
        this.input_sub_location_name == "" ||
        this.input_sub_location_id == "" || 
        this.input_sub_location_category == ""
      );
    },

    saveSubLocation() {
      this.isSubmited = true;
      if (this.isEditing) {
        this.updateSubLocation();
      } else {
        this.createSubLocation();
      }
    },

    createSubLocation() {
      this.addSubLocationDialog = false;
      const formData = new FormData();
      formData.append(
        "sub_location[distribution_center_id]",
        this.input_location,
      );
      formData.append(
        "sub_location[location_type]",
        this.input_sub_location_type,
      );
      formData.append("sub_location[name]", this.input_sub_location_name);
      formData.append("sub_location[code]", this.input_sub_location_id);
      formData.append('sub_location[sub_location_category]', this.input_sub_location_category);


      this.$httpSecured
        .post("/api/v1/warehouse/sub_locations", formData)
        .then((response) => {
          if (response.data) {
            this.addSubLocationDialog = false;
            this.loadData("Sub-Locations");
            this.isSubmited = false;
            this.showAlert("success", "Sub-Location saved successfully");
          } else {
            this.showAlert("error", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showAlert(
            "error",
            error.response.data.error ||
              "Something went wrong from Network" + error,
          );
          this.loading = false;
          this.isSubmited = false;
        });
    },

    updateSubLocation() {
      const formData = new FormData();
      formData.append(
        "sub_location[distribution_center_id]",
        this.input_location,
      );
      formData.append(
        "sub_location[location_type]",
        this.input_sub_location_type,
      );
      formData.append("sub_location[name]", this.input_sub_location_name);
      formData.append("sub_location[code]", this.input_sub_location_id);

      const selected_sl = this.selected.map((x) => x.id);

      this.$httpSecured
        .put(`/api/v1/warehouse/sub_locations/${selected_sl}`, formData)
        .then((response) => {
          if (response.data) {
            this.addSubLocationDialog = false;
            this.loadData("Sub-Locations");
            this.showAlert("success", "Sub-Location updated successfully");
            setTimeout(() => {
              this.isSubmited = false;
              this.isEditing = false;
            }, 100);
          } else {
            this.showAlert("error", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showAlert(
            "error",
            error.response.data.error ||
              "Something went wrong from Network" + error,
          );
          this.loading = false;
          this.isSubmited = false;
        });
    },

    deleteSubLocationConfirmationPopupOpen() {
      if (this.active_tab == "Sub-Locations") {
        this.deleteSubLocationDialog = true;
      }
    },

    addSubLocationPopupOpen() {
      if (this.active_tab == "Sub-Locations") {
        this.input_sub_location_id = "";
        this.input_sub_location_name = "";
        this.input_location = "";
        this.input_sub_location_category = "";
        this.input_sub_location_type = "";
        this.isEditing = false;
        this.addSubLocationDialog = true;
      }
    },

    editSubLocationPopupOpen() {
      if (this.active_tab == "Sub-Locations") {
        this.isEditing = true;
        this.input_sub_location_id = this.selected.map((x) => x.code)[0];
        this.input_sub_location_name = this.selected.map((x) => x.name)[0];
        this.input_location = this.selected.map(
          (x) => x.distribution_center_id,
        )[0];
        this.edit_input_location = this.selected.map(
          (x) => x.distribution_center,
        )[0];
        this.input_sub_location_type = this.selected
          .map((x) => x.location_type)[0]
          .toLowerCase();
          this.input_sub_location_category = this.selected.map(x => x.sub_location_category)[0]
        this.addSubLocationDialog = true;
      }
    },

    sortSubLocationSequencePopupOpen() {
      if (this.active_tab == "Sub-Location Sequence") {
        this.sortSubLocationSequence = true;
        this.$httpSecured
          .get(
            `/api/v1/warehouse/distribution_centers/${this.selected[0].id}/sub_location_sequence`,
          )
          .then((response) => {
            if (response.status === 200) {
              this.sub_locations_items =
                response.data.distribution_center.sub_locations;
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }
    },

    deleteSubLocationsConfirm() {
      const deleteSubLocationsId = this.selected.map((x) => x.id);
      this.$httpSecured
        .delete("/api/v1/warehouse/sub_locations/bulk_delete", {
          params: { ids: deleteSubLocationsId },
        })
        .then((response) => {
          if (response.status == 200) {
            this.loadData("Sub-Locations");
            this.selected = [];
            this.deleteSubLocationDialog = false;
            this.showAlert("success", "Sub Location(s) deleted successfully !");
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.error);
        });
      this.deleteSubLocationDialog = false;
    },

    closePopup() {
      this.deleteSubLocationDialog = false;
      this.addSubLocationDialog = false;
      this.sortSubLocationSequence = false;
      this.showRuleScreen = false;
      this.selected = [];
      this.ruleOptions = this.ruleOptions.map((item) => ({
        ...item,
        Options: [],
        selectedValue: [],
        show: false,
        checked: false,
      }));
    },

    handleClickDefineRule(ApiselectedValue) {
      if(this.category_update == 'storage'){
       this.ruleOptions = [
        {
          ruleName: "Category",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Categories",
          selectedValue: [],
          ApiKey: "categories",
          updatekey: "category"
        },
        {
          ruleName: "Brand",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Brand",
          selectedValue: [],
          ApiKey: "brands",
          updatekey: "brand"
        },
        {
          ruleName: "Grade",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Grade",
          selectedValue: [],
          ApiKey: "grades",
          updatekey: "grade"
        },
        {
          ruleName: "Disposition",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Disposition",
          selectedValue: [],
          ApiKey: "dispositions",
          updatekey: "disposition"
        },
        {
          ruleName: "Article ID",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Article",
          selectedValue: [],
          ApiKey: "article_ids",
          updatekey: "article_ids"
        }
      ]
      }else{
        this.ruleOptions = [
        {
          ruleName: "Category",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Categories",
          selectedValue: [],
          ApiKey: "categories",
          updatekey: "category"
        },
        {
          ruleName: "Brand",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Brand",
          selectedValue: [],
          ApiKey: "brands",
          updatekey: "brand"
        },
        {
          ruleName: "Disposition",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Disposition",
          selectedValue: [],
          ApiKey: "dispositions",
          updatekey: "disposition"
        },
        {
          ruleName: "Article ID",
          show: false,
          checked: false,
          Options: [],
          label: "Valid Article",
          selectedValue: [],
          ApiKey: "article_ids",
          updatekey: "article_ids"
        },
        {
          ruleName: "Pick Up Request Reason",
          show: false,
          checked: false,
          Options: [],
          label: "Pick Up Request Reaso",
          selectedValue: [],
          ApiKey: "pick_up_request_reasons",
          updatekey: "pick_up_request_reasons"
        },
        {
          ruleName: "Outwarding Reason",
          show: false,
          checked: false,
          Options: [],
          label: "Outwarding Reason",
          selectedValue: [],
          ApiKey: "outwarding_reasons",
          updatekey: "outwarding_reasons"
        }
        ]
      }
      this.showRuleScreen = true;
      this.saveRuleBtn = false;
      this.$httpSecured
        .get("/api/v1/warehouse/sub_locations/rule_types", {params : { category_type : this.category_update.toString() }})
        .then((response) => {
          if (response.status === 200) {
            if (ApiselectedValue && ApiselectedValue.sub_location) {
              this.saveRuleBtn = true;
              this.ruleOptions = this.ruleOptions.map((option) => ({
                ...option,
                Options: response.data[option.ApiKey],
                selectedValue: ApiselectedValue.sub_location[option.updatekey],
                show: !!(
                  ApiselectedValue.sub_location[option.updatekey] &&
                  ApiselectedValue.sub_location[option.updatekey].length > 0
                ),
                checked: !!(
                  ApiselectedValue.sub_location[option.updatekey] &&
                  ApiselectedValue.sub_location[option.updatekey].length > 0
                ),
              }));
            } else {
              this.ruleOptions = this.ruleOptions.map((option) => ({
                ...option,
                Options: response.data[option.ApiKey],
              }));
            }
          }
        });
    },

    handleCheckRule(item) {
      const updateRuleOption = this.ruleOptions.map((opt) =>
        opt.ruleName === item.ruleName
          ? {
              ...opt,
              show: !opt.show,
              checked: !opt.checked,
              selectedValue: [],
            }
          : opt,
      );
      this.ruleOptions = updateRuleOption;
      let selectedRule = updateRuleOption.map((item) => item.show);
      if (selectedRule.includes(true)) {
        this.saveRuleBtn = true;
      } else {
        this.saveRuleBtn = false;
      }
    },

    handleSaveRule() {
      const getSelectedrule = {};
      this.ruleOptions.map((option) => {
        getSelectedrule[option.ApiKey] = option.selectedValue;
      });
      let formData = {
          sub_location_ids: this.selected.map(item => item.id), // Common field for both conditions
          category: getSelectedrule.categories,
          brand: getSelectedrule.brands,
          disposition: getSelectedrule.dispositions,
          article_ids: getSelectedrule.article_ids
        };

       
        if (this.category_update === 'storage') {
          formData.grade = getSelectedrule.grades;
        } else {
          formData.pick_up_request_reasons = getSelectedrule.pick_up_request_reasons;
          formData.outwarding_reasons = getSelectedrule.outwarding_reasons;
        }

      this.$httpSecured
        .post("/api/v1/warehouse/sub_locations/update_rules", { ...formData })
        .then((response) => {
          if (response.status === 200) {
            this.showRuleScreen = false;
            this.saveRuleBtn = false;
            this.ruleOptions = this.ruleOptions.map((item) => ({
              ...item,
              Options: [],
              checked: false,
              show: false,
            }));
            this.loadData("Sub-Location Rules");
          }
        });
    },
    handleruleLinkClick(item) {
      let selectedId = "";
      if (item) {
        selectedId = item.id;
        this.selected = [item];
      } else {
        selectedId = this.selected[0].id;
      }
      if (item) {
        this.category_update = item.sub_location_category
        this.$httpSecured
          .get(`api/v1/warehouse/sub_locations/${selectedId}`)
          .then((response) => {
            if (response.status === 200) {
              this.handleClickDefineRule(response.data);
            }
          });
      } else {
        var dc = this.selected.map(x => x.sub_location_category)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index;
        };
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter((item, index, self) => unique(item, index, self));
        if (unique_array.length > 1) {
          this.selected = [];
          this.showAlert("error", "Please select the items from the same category!");
        } else {
          this.category_update = this.selected.length === 1 ? this.selected[0].sub_location_category : unique_array
          this.handleClickDefineRule();
        }
      }
    },
    handleRemoveSelect(ruleOption, current_item) {
      this.ruleOptions = this.ruleOptions.map((item) =>
        item.ruleName === ruleOption.ruleName
          ? {
              ...item,
              selectedValue: item.selectedValue.filter(
                (v) => v !== current_item,
              ),
            }
          : item,
      );
    },
    dataClear() {
      if (this.active_tab == "Sub-Locations") {
        this.sub_location_search = "";
      } else if (this.active_tab == "Sub-Location Rules") {
        this.sub_location_rules_search = "";
      } else {
        this.sub_location_sequence_search = "";
      }
    },
    exportInventoryPopup() {
      if (this.active_tab == "Update Inventory") {
        this.exportinventorypopu = true;
        this.inventory_location = null;
        this.$httpSecured
          .get(
            "/api/v1/warehouse/sub_locations/get_locations?have_sub_locations=true",
          )
          .then((response) => {
            if (response.data) {
              this.InventoryLocation = response.data.locations;
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }

      if (this.active_tab == "Sub-Locations") {
        this.exportinventorypopu = true;
        this.inventory_location = null;
        this.$httpSecured
          .get("/api/v1/warehouse/sub_locations/get_locations")
          .then((response) => {
            if (response.data) {
              this.InventoryLocation = response.data.locations;
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }

      if (this.active_tab == "Sub-Location Sequence") {
        this.exportinventorypopu = true;
        this.inventory_location = null;
        this.$httpSecured
          .get("/api/v1/warehouse/sub_locations/get_locations")
          .then((response) => {
            if (response.data) {
              this.InventoryLocation = response.data.locations;
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }
    },
    downloadInventoryFile() {
      if (this.active_tab == "Update Inventory") {
        this.$httpSecured
          .get(
            `/api/v1/warehouse/put_away/export_inventory.csv?location_id=${this.inventory_location}`,
            {
              responseType: "blob",
            },
          )
          .then((response) => {
            if (response.data) {
              this.InventoryLocation.map((item) => {
                if (item.id == this.inventory_location) {
                  this.inventory_location = item.code;
                }
              });
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${this.inventory_location}_inventories.csv`,
              );
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }
      if (this.active_tab == "Sub-Locations") {
        this.$httpSecured
          .get(
            `api/v1/warehouse/sub_locations/export_sublocations.csv?location_id=${this.inventory_location}`,
            {
              responseType: "blob",
            },
          )
          .then((response) => {
            if (response.data) {
              this.InventoryLocation.map((item) => {
                if (item.id == this.inventory_location) {
                  this.inventory_location = item.code;
                }
              });
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${this.inventory_location}_sublocations.csv`,
              );
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }
      if (this.active_tab == "Sub-Location Sequence") {
        this.$httpSecured
          .get(
            `/api/v1/warehouse/sub_locations/export_sublocation_sequence?location_id=${this.inventory_location}`,
            {
              responseType: "blob",
            },
          )
          .then((response) => {
            if (response.data) {
              this.InventoryLocation.map((item) => {
                if (item.id == this.inventory_location) {
                  this.inventory_location = item.code;
                }
              });
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${this.inventory_location}_sublocations.csv`,
              );
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
          });
      }
    },
    importFile() {
      this.number++;
      if (this.v$.file.$invalid) {
        this.file_required = true;
        this.number = 0;
        return;
      } else {
        this.file_required = false;
      }
      let formData = new FormData();

      if (this.file.name.split(".").pop() != "csv") {
        this.$toast.error("Only CSV files can be imported");
        this.number = 0;
        return;
      }
      formData.append("file", this.file);
      this.show = true;
      if (this.active_tab == "Update Inventory") {
        this.$httpSecured
          .post("/api/v1/warehouse/put_away/import_inventory", formData)
          .then((response) => {
            this.show = false;
            this.file = "";
            this.uploadinventorypopup = false;
            this.$toast.success("File uploaded successfully");
          })
          .catch((error) => {
            this.number = 0;
            this.show = false;
            this.$toast.error(error.response.data.error);
          });
      }
      if (this.active_tab == "Sub-Locations") {
        this.$httpSecured
          .post("api/v1/warehouse/sub_locations/import_sublocations", formData)
          .then((response) => {
            this.show = false;
            this.file = "";
            this.uploadinventorypopup = false;
            this.$toast.success("File uploaded successfully");
          })
          .catch((error) => {
            this.number = 0;
            this.show = false;
            this.$toast.error(error.response.data.error);
          });
      }

      if (this.active_tab == "Sub-Location Sequence") {
        this.$httpSecured
          .post(
            "/api/v1/warehouse/sub_locations/import_sublocation_sequence",
            formData,
          )
          .then((response) => {
            this.show = false;
            this.file = "";
            this.uploadinventorypopup = false;
            this.$toast.success("File uploaded successfully");
          })
          .catch((error) => {
            this.number = 0;
            this.show = false;
            this.$toast.error(error.response.data.error);
          });
      }
    },
    selectFile() {
      this.file = this.$refs.file.files[0];
      if (this.v$.file.$invalid) {
        this.file_required = true;
      } else {
        this.file_required = false;
      }
    },
    uploadInventoryDialog() {
      this.uploadinventorypopup = true;
      this.number = 0;
      // this.$refs.file.type = "text";
      // this.$refs.file.type = "file";
    },
    downloadExporRules() {
      this.$httpSecured
        .get("master_files/sub_location_rules.csv")
        .then((response) => {
          if (response.data) {
            const url = `${API_URL}/master_files/sub_location_rules.csv`
            const link = document.createElement("a");
            link.href = url;
            link.download = "file.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },

    update_binloaction_format(){
      this.input_sub_location_name = this.input_sub_location_name.replace(/[^a-zA-Z0-9 .\-_]/g, '');
    },
    update_binloaction_id_format(){
      this.input_sub_location_id = this.input_sub_location_id.replace(/[^a-zA-Z0-9 .\-_]/g, '');
    }
  },
};
</script>
<style scoped>
/* .v-select__selections{
  display: none;
} */

.rule-type_option {
  border: 1px solid #000000;
  padding: 4px 8px;
  border-radius: 5px;
  margin: 1px 2px;
}
.selected_rule_box {
  display: flex;
  flex-wrap: wrap;
}
.rule-ct_chips .v-chip {
  display: none;
}
.rule-ct_chips {
  max-width: 100%;
}
.v-dialog:has(.filter-putaway) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}
.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}
.custom-control_outlined button:focus {
  outline: none;
}
.btn-cancel {
  border: 1px solid #2196f3 !important;
  color: #2196f3 !important;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 310px) !important;
}
.text-break {
  display: none;
}

@media (max-width: 1510px) {
  .text-break {
    display: block;
  }
}
.filter_ui{
  margin-left: 8px !important;
  margin-top: 30px !important;
}
</style>
